export const blockIconsSocialPersonRemoveNew = (
	<span className='material-symbols-outlined'>person_remove</span>
);
